import { useEffect } from "react";
import { resolveBrand } from "../config/brand";

export function useBrandAssets() {
  useEffect(() => {
    const brand = resolveBrand();

    // Title
    document.title = brand.title;

    // Favicon
    const setLink = (rel, href) => {
      let link = document.querySelector(`link[rel='${rel}']`);
      if (!link) {
        link = document.createElement("link");
        link.rel = rel;
        document.head.appendChild(link);
      }
      link.href = href;
    };

    setLink("icon", `${brand.publicPath}/favicon.png`);
    setLink("apple-touch-icon", `${brand.publicPath}/apple-touch-icon.png`);

    // Manifest (importante para PWA)
    let manifest = document.querySelector("link[rel='manifest']");
    if (!manifest) {
      manifest = document.createElement("link");
      manifest.rel = "manifest";
      document.head.appendChild(manifest);
    }
    manifest.href = `${brand.publicPath}/manifest.json`;
  }, []);
}
